import { Component, OnInit } from '@angular/core';
import { SocketService } from 'src/app/services/socket.service';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AlarmaDetalleDialogComponent } from './alarma-detalle-dialog/alarma-detalle-dialog.component';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ConfirmacionComponent } from 'src/app/home/confirmacion/confirmacion.component';
import { tryCatch } from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-alerta-flotante',
  templateUrl: './alerta-flotante.component.html',
  styleUrls: ['./alerta-flotante.component.scss']
})

export class AlertaFlotanteComponent implements OnInit {

  reintentos = 5;
  alarmas = [];
  histalarmas = [];
  parpadea = false;
  count = 0;
  panelAbierto = false;
  agente_id = null;

  animarNumero = false;
  audio = new Audio('assets/audio/alerta.wav');
  selectedTab = 0;

  constructor(
    private gateway: GatewayService,
    // private alarmasService: AlarmasService,
    private localsave: LocalSaveService,
    private socketService: SocketService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private clienteinfo: ClienteinfoService,
    private router: Router,
  ) {
    this.agente_id = this.localsave.get('usuarioPGV').idagente;
  }

  ngOnInit() {
    // cargar alarmas pendientes de BD
    this.getPendientes();

    // cuando llega una alarma por socket
    this.socketService.onNuevaAlarma((data) => {
      // this.alarmas.push(data);
      // this.updateState();
      this.getPendientes();
    });

    // cuando otro agente toma una alarma
    this.socketService.onAlarmaTomada((data) => {
      this.alarmas = this.alarmas.filter(a => a.id !== data.id);
      this.updateState();
    });
  }

  getPendientes() {
    return new Promise(async (resolve, reject) => {
      this.gateway.get('getPendientes', { agente_id: this.localsave.get('usuarioPGV').idagente, idarea: this.localsave.get('usuarioPGV').IDAREA, idareaagente: this.localsave.get('usuarioPGV').idareaagente })
        .then((result: any) => {
          this.alarmas = Array.isArray(result) ? result : [];

          if (this.alarmas.length > this.count) {
            // reproducir sonido
            this.audio.volume = 0.7;
            this.audio.currentTime = 0;

            this.audio.play().catch(err => {
              // Error handled silently
            });
          }
          this.updateState();
          resolve(true);
        });

      this.gateway.get('getHistAlarmasxAgente', { agente_id: this.localsave.get('usuarioPGV').idagente, idarea: this.localsave.get('usuarioPGV').IDAREA, idareaagente: this.localsave.get('usuarioPGV').idareaagente })
        .then((result: any) => {
          this.histalarmas = Array.isArray(result) ? result : [];
        });
    });
  }

  updateState() {
    this.count = this.alarmas.length;
    // activar animaciones
    this.parpadea = this.count > 0;
    this.animarNumero = this.count > 0;
  }

  abrirPanel() {
    // if (this.count == 0) return;
    this.panelAbierto = !this.panelAbierto;
    this.selectedTab = 0;
    this.getPendientes();
  }

  tomarAlarma(alarma) {
    if (alarma.agente_id === this.agente_id) {
      this.verDetalleAlarma(alarma);
    } else {
      this.gateway.get('tomarAlarma', { id: alarma.id, agente_id: this.localsave.get('usuarioPGV').idagente })
        .then(async (result: any) => {
          if (result.response === 1) {
            // enviar socket a los otros agentes
            this.socketService.tomarAlarma({ id: alarma.id });
            await this.getPendientes();
            const alarmaEncontrada = this.alarmas.find(a => a.id === alarma.id);
            if (alarmaEncontrada) {
              this.verDetalleAlarma(alarmaEncontrada);
            }
          } else {
            this.getPendientes();
            this.snackbar.open(result.msgerror, 'Cerrar', { duration: 7000 });
          }

        });
    }
  }

  verDetalleAlarma(alarma) {
    /**
     * Validar si es programador de citas, si es programador de citas entonces:
     *  - cerrar la llamada del cliente actual y crear una llamada nueva con el nuevo cliente
     *  - refrescar los datos del nuevo cliente.
     *  - gestionar y al crear la cita, 
     */

    /*
    if (this.localsave.get('usuarioPGV').idareaagente == 2 || this.localsave.get('usuarioPGV').idareaagente == 7) {
      this.gateway.get('gestionarclienteahora', alarma)
        .then((result: any) => {
          if (result.response == 2) {
            this.gateway.get('cambio_estado', { IDAGENTE: this.localsave.get('usuarioPGV').idagente, IDESTADO: 1, IDCAMPANA: result.result.idcampana })
              .then((result: any) => {
                this.clienteinfo.setState(1);

                const current = this.router.url;
                if (current.includes('homeagente/atencioncliente')) {
                  this.router.navigate(['homeagente/atencionclientes']);
                } else {
                  this.router.navigate(['homeagente/atencioncliente']);
                }
                // this.spinner.hide();
              });
          } else {
            this.snackbar.open(`No fue posible completar la acción en este momento. Por favor, inténtalo nuevamente más tarde.`, 'Cerrar', { duration: 8000 });
            // this.spinner.hide();
          }
        });
    } else {
      const dialogRef = this.dialog.open(AlarmaDetalleDialogComponent, {
        width: '500px',
        data: alarma,
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) return;
        alarma['accion'] = result.accion;
        alarma['comentario_agente'] = result.comentario;
        this.gateway.get('resolverAlarma', alarma)
          .then((result: any) => {
            this.socketService.enviarRespuesta(`tecnico_${alarma.tecnico_id}`, alarma);
            this.getPendientes();
          });
      });
    }
    */

    const dialogRef = this.dialog.open(AlarmaDetalleDialogComponent, {
      width: '500px',
      data: { ...alarma, show_options: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      if (result.accion === 3) {
        this.gateway.get('gestionarclienteahora', alarma)
          .then((result: any) => {
            if (result.response === 1) {
              this.gateway.get('cambio_estado', { IDAGENTE: this.localsave.get('usuarioPGV').idagente, IDESTADO: 1, IDCAMPANA: result.result.idcampana })
                .then((result: any) => {
                  this.clienteinfo.setState(1);

                  const current = this.router.url;
                  if (current.includes('homeagente/atencioncliente')) {
                    this.router.navigate(['homeagente/atencionclientes']);
                  } else {
                    this.router.navigate(['homeagente/atencioncliente']);
                  }
                  // this.spinner.hide();
                });
            } else {
              this.snackbar.open(result.msgerror, 'Cerrar', { duration: 8000 });
              // this.spinner.hide();
            }
          });
      } else {
        alarma['accion'] = result.accion;
        alarma['comentario_agente'] = result.comentario;
        this.gateway.get('resolverAlarma', alarma)
          .then((result: any) => {
            this.socketService.enviarRespuesta(`tecnico_${alarma.tecnico_id}`, alarma);
            this.getPendientes();
          });
      }
    });
  }

  vermasInfoAlarma(alarma) {
    const dialogRef = this.dialog.open(AlarmaDetalleDialogComponent, {
      width: '500px',
      data: { ...alarma, show_options: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
    });
  }

  reenviarAlarma(alarma) {
    try {
      const jsonrespuesta = alarma.jsonrespuesta ? JSON.parse(alarma.jsonrespuesta) : null;
      if (jsonrespuesta && alarma.reintento < this.reintentos) {
        alarma.reintento++;
        const dialogRef = this.dialog.open(ConfirmacionComponent, {
          disableClose: true,
          width: '350px',
          data: { sms: 'reenviar la respuesta al técnico', addcomment: false }
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result.resp) {
            this.gateway.get('reintentoResolverAlarma', alarma)
              .then((result: any) => {
                this.socketService.enviarRespuesta(`tecnico_${alarma.tecnico_id}`, jsonrespuesta);
                this.getPendientes();
              });
          }
        });
      } else {
        if (alarma.reintento >= this.reintentos) {
          this.snackbar.open(`Has superado el número de ${this.reintentos} reintento(s) valido(s).`, 'Cerrar', { duration: 3000 });
        } else {
          this.snackbar.open('No se pudo reenviar la alarma. Intentelo más tarde.', 'Cerrar', { duration: 3000 });
        }
      }
    } catch (error) {
      this.snackbar.open('No se pudo reenviar la alarma. Intentelo más tarde.', 'Cerrar', { duration: 3000 });
    }
  }

  // const dialogRef = this.dialog.open(ConfirmacionComponent, {
  //       disableClose: true,
  //       width: '350px',
  //       data: { sms: 'reenviar la respuesta al técnico', addcomment: false }
  //     });

  //     dialogRef.afterClosed().subscribe((result) => {
  //       if (result.resp) {

  //       }
  //     });
}
